export default __webpack_public_path__ + "static/media/Opposites01_10.27fb1cae.png";